import React, { useContext } from 'react';
import { Button } from 'antd';
import coinPng from 'assets/images/coin-shadow.png';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';

interface Props {
  visible: boolean;
  setVisible: Function;
  closeTask?: Function;
}

const ModalFinish2 = ({ visible, setVisible, closeTask }: Props) => {
  return (
    <ModalEndSubmit
      visible={visible}
      setVisible={setVisible}
      buttonAction={{ hidden: true }}
      modal={{
        title: 'We´re finding you a title company',
        description: (
          <h4 className="h4 h4-w4">
            {`We´ll be in touch via email when we have one.`}
          </h4>
        )
      }}
      className="modal-normal"
      icon={coinPng}
      buttonSubmit={
        <Button
          htmlType="submit"
          className="button button-modal-ok"
          onClick={() => {
            setVisible(false);
            if(closeTask)
              closeTask();
          }}
        >
          Back to dashboard
        </Button>
      }
    />
  );
};
export default ModalFinish2;
